"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tax_rate_api = void 0;

var _lsfastapiClient = require("@lsoft/lsfastapi-client");

var openapi = {
  openapi: "3.0.2",
  info: {
    title: "tax-rate-api",
    version: "1.1.0"
  },
  paths: {
    "/tax_rate/tax_rates_compact": {
      get: {
        tags: ["tax_rate"],
        summary: "Tax Rates Compact Get",
        operationId: "tax_rate_tax_rates_compact_get",
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          }
        }
      }
    },
    "/healthz": {
      get: {
        summary: "Healthz Get",
        operationId: "healthz_get_healthz_get",
        responses: {
          "200": {
            description: "Successful Response",
            content: {
              "application/json": {
                schema: {}
              }
            }
          }
        }
      }
    }
  }
};
var tax_rate_api = (0, _lsfastapiClient.Api)(openapi);
exports.tax_rate_api = tax_rate_api;
//# sourceMappingURL=index.js.map